import { Helpers } from '../../helpers';
import { IProductionStatus } from '../../interfaces/iproduction-status';
import { Asset } from '../asset';

export class ProductionStatusBase {
  ProductionStatusId: number;
  Description: string;
  SortOrder: number | null;
  ProductionStatusCode: string | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Assets_ProductionStatus?: Array<Asset> | null;

  constructor(item?: IProductionStatus) {
    if (item) {

      this.ProductionStatusId = item.ProductionStatusId;
      this.Description = item.Description;
      this.SortOrder = item.SortOrder;
      this.ProductionStatusCode = item.ProductionStatusCode;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Assets_ProductionStatus = Helpers.createClassArray(Asset, item.Assets_ProductionStatus);
    }
  }
}